module.exports = __webpack_public_path__ + "img/banner_left.99d24149.png";